import { ethers as o } from "ethers";
import { WETHContractAbi as n } from "@deorderbook/contracts/abi";
import { WETHAddress as e } from "@deorderbook/contracts";
import { signer as c, provider as i } from "./provider.mjs";
const s = () => new o.Contract(e, n), C = (r = !1) => {
  const t = s();
  return r ? t.connect(c) : t.connect(i);
};
export {
  s as initWETHContract,
  C as useWETHContract
};
//# sourceMappingURL=wethContract.mjs.map
